













import Component from 'vue-class-component'
import RespondecoHeader from './header/header.vue'
import RespondecoFooter from './footer.vue'
import Vue from 'vue'

@Component({
  components: {
    RespondecoHeader,
    RespondecoFooter,
  },
})
export default class Main extends Vue {}
